import 'slick-carousel/slick/slick'
import Forms from './forms'
import Headroom from 'headroom.js';
import 'bootstrap'

export default {
  init() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    this.makeSlider()
    $('[data-control="newsletter-form"]').newsletter();

    const form = new Forms({
      wrap: '.field-wrap',
      forms: 'form.wpcf7-form',
    });
    form.init();
    const newsletter = new Forms({
      wrap: '.field-wrap',
      forms: 'form.newsletter-form__inputs',
    });
    newsletter.init();
    // eslint-disable-next-line no-undef
    // var userFeed = new Instafeed({
    //   get: 'user',
    //   userId: '945899373',
    //   clientId: '5d102b9b8e734de88465715e78924c07',
    //   accessToken: '945899373.5d102b9.b2f821b244144aedb47e96877553b37e',
    //   resolution: 'standard_resolution',
    //   template: '<a href="{{link}}" target="_blank" id="{{id}}"><img src="{{image}}" /></a>',
    //   sortBy: 'most-recent',
    //   limit: 4,
    //   links: false,
    // });
    // userFeed.run();

    // Nav header actions
    $('.top-nav__list .top-nav__nav-link').on('mouseover', function() {
      $('.top-nav__list').addClass('hovered');
      $(this).addClass('selected');
      $('.top-nav__dropdown').removeClass('open');
      $('.top-nav__arrow').removeClass('pseudoelement-smooth');
      if ($(this).parent().hasClass('top-nav__arrow')) {
        var x = '[data-droptarget="' + $(this).attr('data-dropbtn') + '"]';
        $(x).addClass('open');
        $('.top-nav__arrow').addClass('pseudoelement-smooth');
        $(this).parent().removeClass('pseudoelement-smooth');
      }
      else {
        $('.top-nav__list .top-nav__nav-link').addClass('selected');
        $(this).removeClass('selected');
      }
    });
    $('.top-nav__list .top-nav__nav-link').on('mouseleave', function() {
      if (!$('.top-nav__dropdown').hasClass('open')) {
        $('.top-nav__list').removeClass('hovered');
        $('.top-nav__nav-link').removeClass('selected');
      }
    });
    $('.top-nav__dropdown-link').on('mouseover', function() {
      $('.top-nav__dropdown').addClass('hovered');
    });
    $('.top-nav__dropdown-link').on('mouseout', function() {
      $('.top-nav__dropdown').removeClass('hovered');
    });
    $('.top-nav__dropdown, .top-nav').on('mouseleave', function() {
      $('.top-nav__dropdown').removeClass('hovered, open');
      $('.top-nav__list').removeClass('hovered');
      $('.top-nav__nav-link').removeClass('selected');
      $(this).removeClass('open');
      $('.top-nav__arrow').removeClass('pseudoelement-smooth');
    });
    $('button').on('click', function() {
      $(this).toggleClass('is-open');
    });
    $('.top-nav__burger').on('click', function () {
      $('.mobile-menu').toggleClass('open-mobile');
      $('body').toggleClass('body-hidden');
      $('.shadow ').toggleClass('show-shadow');
    });
    $('.mobile-menu__burger').on('click', function () {
      $('.mobile-menu').toggleClass('open-mobile');
      $('body').toggleClass('body-hidden');
      $('.shadow ').toggleClass('show-shadow');
    });

    var myElement = document.querySelector('header');
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(myElement);
    // initialise
    headroom.init();

    // $('.newsletter-form__button').on('click', function (e) {
    //   e.preventDefault();
    //   $('.newsletter-form__thank-you').addClass('visible');
    // });
  },
  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
  makeSlider () {
    if (window._detect.is('ie11')) {
      return;
    }
    $(function() {$('.slider-all').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js